module.exports = __webpack_public_path__ + "static/media/filters-final.37c87d0c.svg";